!function() {
  var e = {
    334: function(e) {
      function t(e, t = 100, o = {}) {
        if ("function" != typeof e) throw new TypeError(`Expected the first parameter to be a function, got \`${typeof e}\`.`);
        if (t < 0) throw new RangeError("`wait` must not be negative.");
        const {immediate: r} = "boolean" == typeof o ? {
          immediate: o
        } : o;
        let i, n, s, c, a;
        function d() {
          const t = i, o = n;
          return i = void 0, n = void 0, a = e.apply(t, o), a;
        }
        function u() {
          const e = Date.now() - c;
          e < t && e >= 0 ? s = setTimeout(u, t - e) : (s = void 0, r || (a = d()));
        }
        const l = function(...e) {
          if (i && this !== i) throw new Error("Debounced method called with different contexts.");
          i = this, n = e, c = Date.now();
          const o = r && !s;
          return s || (s = setTimeout(u, t)), o && (a = d()), a;
        };
        return l.clear = () => {
          s && (clearTimeout(s), s = void 0);
        }, l.flush = () => {
          s && l.trigger();
        }, l.trigger = () => {
          a = d(), l.clear();
        }, l;
      }
      e.exports.debounce = t, e.exports = t;
    },
    837: function() {
      window.Shopify = window.Shopify || {}, window.Shopify.MultiStore = [ {
        storeCode: "GB",
        storeName: "United Kingdom",
        storeUrl: "https://www.davidaustinroses.co.uk",
        supportedLanguages: "EN",
        supportedCurrencies: "GBP",
        currencySymbol: "£",
        supportedStores: "GB"
      }, {
        storeCode: "FR",
        storeName: "France",
        storeUrl: "https://eu.davidaustinroses.com",
        supportedLanguages: "FR",
        supportedCurrencies: "EUR",
        currencySymbol: "€",
        supportedStores: "EU"
      }, {
        storeCode: "DE",
        storeName: "Germany",
        storeUrl: "https://eu.davidaustinroses.com",
        supportedLanguages: "DE",
        supportedCurrencies: "EUR",
        currencySymbol: "€",
        supportedStores: "EU"
      }, {
        storeCode: "EU",
        storeName: "Europe",
        storeUrl: "https://eu.davidaustinroses.com",
        supportedLanguages: "EN",
        supportedCurrencies: "EUR",
        currencySymbol: "€",
        supportedStores: "AD,AL,AM,AT,AX,BA,BE,BG,BY,CH,CY,CZ,DK,DE,EE,ES,FI,FO,FR,GE,GI,GR,HR,HU,IE,IS,IT,LT,LU,LV,MC,MK,MT,NL,NO,PL,PT,RO,SE,SI,SK,SM,UA,VA,CH"
      }, {
        storeCode: "US",
        storeName: "United States",
        storeUrl: "https://www.davidaustinroses.com",
        supportedLanguages: "EN",
        supportedCurrencies: "USD",
        currencySymbol: "$",
        supportedStores: "US"
      }, {
        storeCode: "JP",
        storeName: "Japan",
        storeUrl: "https://www.davidaustinroses.co.jp",
        supportedLanguages: "JA",
        supportedCurrencies: "JPY",
        currencySymbol: "¥",
        supportedStores: "JP"
      }, {
        storeCode: "AU",
        storeName: "Australia",
        storeUrl: "https://www.davidaustinrosesaustralia.com",
        supportedLanguages: "EN",
        supportedCurrencies: "AUD",
        currencySymbol: "$",
        supportedStores: "AU"
      } ];
    }
  }, t = {};
  function o(r) {
    var i = t[r];
    if (void 0 !== i) return i.exports;
    var n = t[r] = {
      exports: {}
    };
    return e[r](n, n.exports, o), n.exports;
  }
  o.n = function(e) {
    var t = e && e.__esModule ? function() {
      return e.default;
    } : function() {
      return e;
    };
    return o.d(t, {
      a: t
    }), t;
  }, o.d = function(e, t) {
    for (var r in t) o.o(t, r) && !o.o(e, r) && Object.defineProperty(e, r, {
      enumerable: !0,
      get: t[r]
    });
  }, o.o = function(e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, function() {
    "use strict";
    o(837);
    var e = o(334), t = o.n(e);
    new class {
      loading=[];
      header=document.querySelector("header");
      async importScript(e) {
        const t = e.tagName.toLowerCase(), o = "127.0.0.1" === location.hostname || Shopify && Shopify.theme && -1 !== Shopify.theme.name.indexOf("Development") || Shopify.designMode;
        if (-1 === this.loading.indexOf(t) && (this.loading.push(t), !customElements.get(t))) {
          var r = document.createElement("script");
          r.src = `${window.settings.asset_url || "/assets/"}${t}.js?v=${o ? Date.now() : window.settings.asset_revision || Date.now()}`, 
          r.async = !0, o && (r.onload = () => console.info(`Loaded: ${t}`)), r.onerror = () => console.warn(`Failed to load ${t}.`) && this.loading.splice(this.loading.indexOf(t)), 
          document.body.appendChild(r);
        }
      }
      loadScript(e) {
        if (e.hasAttribute("data-autoload")) this.importScript(e); else {
          new IntersectionObserver((async (t, o) => {
            t.forEach((async t => {
              t.isIntersecting && (this.importScript(e), o.disconnect());
            }));
          }), {
            rootMargin: "0px 0px 100% 0px"
          }).observe(e);
        }
      }
      initJavascript() {
        document.querySelectorAll("[data-async]").forEach((e => this.loadScript(e)));
        new MutationObserver(((e, t) => {
          e.forEach((e => {
            e.target.querySelectorAll("[data-async]").forEach((e => this.loadScript(e)));
          }));
        })).observe(document.querySelector("body"), {
          childList: !0,
          subtree: !0,
          characterData: !1,
          attributes: !1
        });
      }
      initCloser() {
        document.addEventListener("keydown", (e => {
          "Escape" === e.key && document.querySelectorAll('[type="checkbox"][hidden].peer,[type="checkbox"].hidden.peer').forEach((e => e.checked = !1)), 
          document.body.classList.remove("overflow-hidden");
        }));
      }
      initScrollLock() {
        const e = () => setTimeout((() => [ ...document.querySelectorAll("[data-locker]") ].filter((e => e.checked)).length ? document.body.classList.add("overflow-hidden") : document.body.classList.remove("overflow-hidden")), 100);
        document.body.addEventListener("input", (() => t()(e(), 300))), document.body.addEventListener("click", (() => t()(e(), 300)));
      }
      initClicks() {
        document.body.addEventListener("click", (e => {
          switch (e.target.tagName.toUpperCase()) {
           case "LABEL":
            (t = document.getElementById(e.target.getAttribute("for"))) && t.hasAttribute("hidden") && (e.preventDefault(), 
            e.stopPropagation(), t.checked = !t.checked);
            break;

           case "INPUT":
            "Search" == e.target.id && e.target.checked && (e.target.checked = !1);
            break;

           case "BUTTON":
           case "A":
            if (e.target.getAttribute("href")?.match(/\/cart$/) && !e.target.closest("shopping-cart")) {
              e.preventDefault(), document.querySelector("#Cart").checked = !document.querySelector("#Cart").checked;
              const t = document.querySelector("[data-track-cart]")?.textContent, o = t ? JSON.parse(t) : null;
              Shopify.analytics.publish("custom_cart_viewed", {
                cart: o
              });
            } else if (e.target.hasAttribute("data-popup") && document.getElementById(e.target.getAttribute("data-popup")) || e.target.hasAttribute("data-popup") && document.querySelector(`input#${e.target.getAttribute("data-popup")}`)) {
              const t = document.getElementById(e.target.getAttribute("data-popup"));
              t && (e.preventDefault(), t.checked = !0);
            } else if (e.target.getAttribute("href")?.match(/^#/) && "#" !== e.target.getAttribute("href")) {
              var t;
              (t = document.querySelector(e.target.getAttribute("href"))) && (e.preventDefault(), 
              window.scrollTo({
                top: t.offsetTop - this.header?.clientHeight,
                left: 0,
                behavior: "smooth"
              }));
            }
          }
        }));
      }
      trackRecentlyViewed() {
        Shopify = Shopify || {}, Shopify.recentlyViewed = JSON.parse(localStorage.getItem("recentlyViewed")) || [];
        const e = location.href.match("/products/([^?#]+)");
        e && !Shopify.recentlyViewed.includes(e[1]) && (Shopify.recentlyViewed.unshift(e[1]), 
        Shopify.recentlyViewed = Shopify.recentlyViewed.slice(0, 8), localStorage.setItem("recentlyViewed", JSON.stringify(Shopify.recentlyViewed)));
      }
      visualViewport() {
        document.documentElement.style.setProperty("--visual-viewport", `${window.visualViewport.height}px`), 
        document.documentElement.style.setProperty("--header-height", `${document.querySelector("header")?.clientHeight}px`);
      }
      constructor() {
        window.Shopify = window.Shopify || {}, Shopify.debounce = t(), this.initJavascript(), 
        this.initCloser(), this.initClicks(), this.trackRecentlyViewed(), document.addEventListener("DOMContentLoaded", (() => {
          this.visualViewport(), (window.visualViewport || window).addEventListener("resize", t()(this.visualViewport, 300), {
            passive: !0
          });
        }));
      }
    }, window.Geo = new class {
      cookie=!1;
      cookieSelector="geolocation";
      isCurrentStore(e) {
        return e.storeCode === window.settings.storeCode;
      }
      getRedirectOptionTemplate() {
        return Shopify.MultiStore.map((e => "FR" === e.storeCode || "DE" === e.storeCode ? "" : `\n        <option\n          value="${e.storeCode}"\n          data-store-code="${e.storeCode}"\n          data-store-url="${e.storeUrl}"\n          ${this.isCurrentStore(e) ? "selected" : ""}\n        >\n          ${e.storeName} (${e.currencySymbol})\n        </option>`)).join("");
      }
      getRedirectURL(e) {
        const t = Shopify.MultiStore.filter((t => t.storeCode === e))[0];
        return t ? `${t.storeUrl.replace(/\/$/, "")}${window.Geo.checkRedirectMetafields(e)}` : null;
      }
      checkRedirectMetafields(e) {
        if (!window.redirect) return "/";
        let t;
        for (const [o, r] of Object.entries(window.redirect)) e === o && r && (t = "/" === r.charAt(0) ? r : `/${r}`);
        return t || "/";
      }
      setGeolocationCookie(e) {
        sessionStorage.setItem(this.cookieSelector, JSON.stringify(e));
      }
      getGeolocationCookie() {
        const e = sessionStorage.getItem(this.cookieSelector);
        return !(!e || !JSON.parse(e).detected_values?.country_name) && JSON.parse(e);
      }
      getCountryName() {
        return this.cookie.detected_values.country.name;
      }
      getCountryCode() {
        return this.cookie.detected_values.country.handle;
      }
      async init() {
        let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        fetch(Shopify.routes.root + "browsing_context_suggestions.json").then((e => e.json())).then((t => {
          this.cookie = t, this.setGeolocationCookie(t), e && e(t);
        })).catch((e => {
          console.warn(e);
        }));
      }
      getLocation() {
        let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        this.cookie = this.getGeolocationCookie(), this.cookie || this.init(e);
      }
      constructor() {
        window.Geo = this;
      }
    };
  }();
}();